import { render, staticRenderFns } from "./CaseKitchenAid.vue?vue&type=template&id=2bafb035&lang=pug"
import script from "./CaseKitchenAid.vue?vue&type=script&lang=js"
export * from "./CaseKitchenAid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports